import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Highcharts from "highcharts/highcharts.js";
import highchartsMore from "highcharts/highcharts-more.js"
import solidgauge from "highcharts/modules/solid-gauge.js";
import HighchartsReact from "highcharts-react-official";
import './ActivityTracker.css'
import getMuiTheme from 'material-ui/styles/getMuiTheme';

highchartsMore(Highcharts);
solidgauge(Highcharts);

class StepGauge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            GaugeChart: {
                chart: {
                    type: "solidgauge",
                    backgroundColor: 'none',
                    height:'300px'
                },

                title: {
                    text: null,
                },

                pane: {
                    startAngle: -140,
                    endAngle: 140,

                    background: [{
                        shape:'arc',
                        startAngle: -140,
                        endAngle: 140,
                        outerRadius: '104%',
                        innerRadius: '95%',
                        backgroundColor: '#c8c8c8',
                        borderWidth: 0,
                    }]
                },

                yAxis: {
                    min: 0,
                    max: this.props.goal,
                    lineWidth: 0,
                    tickInterval: null,
                    tickWidth:'2px',
                    tickColor:'rgba(0,0,0,0)',
                    minorTickWidth:'2px',
                    minorTickColor: '#c8c8c8',
                    minorTickInterval:this.props.goal * .01,
                    tickPosition: 'inside',
                    offset: Math.round(window.screen.width*0.015) * -1,
                    minorTickLength:4,
                    tickLength:4,
                    labels:{
                        enabled:false,
                    },
                },
                tooltip: {
                    enabled: false,
                },

                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            enabled: false
                        },
                        // linecap: 'round',
                        stickyTracking: false,
                        // rounded: true
                    },
                },

                series: [{
                    type: 'solidgauge',
                    dataLabels: {
                        enabled: false
                    },
                    data: [{
                        color: '#E85E56',
                        radius: '104%',
                        innerRadius: '95%',
                        y: this.props.steps
                    }]
                }]
            }
        }
    }

    componentDidMount(){
        // const height = this.divElement.clientHeight;
        // let gauge = {...this.state.GaugeChart}
        // gauge.chart.height = height;
        // this.setState({GaugeChart:gauge});
    }



    render() {

        return (
            <div id={'activity-chart-solidguage-container'}>
                <div id={'activity-chart-solidgauge'} ref={ (divElement) => { this.divElement = divElement } }>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.state.GaugeChart}
                    />
                    <div id={'activity-chart-solidgauge-label'}>
                        <div>
                            <div><span id={'activity-chart-solidgauge-subtext'} className={'grey-font'}>Today's Steps</span></div>
                            <div><span id={'activity-chart-solidgauge-text'} style={{color:getMuiTheme(window.muiTheme).palette.primary1Color}}>{this.props.steps}</span></div>
                            <div><span id={'activity-chart-solidgauge-subtext'}  className={'grey-font'}>Goal: {this.props.goal}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default StepGauge;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/StepGauge.js